// $(document).ready(function () {
//
//   $('[data-toggle="tooltip"]').tooltip();
//
//   if (!getCookie("region-select")) {
//     $('.region-bar').slideDown("400");
//   }
//
//   // region bar hide
//   $(".js-close-region-bar").on('click', function(e){
//       setCookie("region-select", true, 3650);
//       $('.region-bar').hide();
//   });
//
//
//
//   // search hover fade
//   $(".search-panel__body .product-basic").hover(function(e){
//     $(".search-panel__body .product-basic").addClass('inactive');
//     $(this).removeClass('inactive').addClass('active');
//   }, function(e){
//     $(".search-panel__body .product-basic").removeClass('inactive').removeClass('active');
//   });
//
//had to rework this with delegation - scottb
	$("body").on({
		mouseenter: function () {
			$(".product-basic").addClass('inactive');
			$(this).removeClass('inactive').addClass('active');
		},
		mouseleave: function () {
			$("a.product-basic").removeClass('inactive').removeClass('active');
		}
	},'a.product-basic');

	// Sort / Search

	var globalGridClasses = 'cards--col-1 cards--col-2 cards--col-3 cards--col-4 cards--col-5 cards--col-6 cards--col-sm-1 cards--col-sm-2 cards--col-sm-3 cards--col-sm-4 cards--col-sm-5 cards--col-sm-6 cards--col-md-1 cards--col-md-2 cards--col-md-3 cards--col-md-4 cards--col-md-5 cards--col-md-6 products--col-1 products--col-2 products--col-3 products--col-4 products--col-5 products--col-6 products--col-sm-1 products--col-sm-2 products--col-sm-3 products--col-sm-4 products--col-sm-5 products--col-sm-6 products--col-md-1 products--col-md-2 products--col-md-3 products--col-md-4 products--col-md-5 products--col-md-6 ';
//
//
//   // Sort / Search
//
//   var globalGridClasses = 'cards--col-1 cards--col-2 cards--col-3 cards--col-4 cards--col-5 cards--col-6 cards--col-sm-1 cards--col-sm-2 cards--col-sm-3 cards--col-sm-4 cards--col-sm-5 cards--col-sm-6 cards--col-md-1 cards--col-md-2 cards--col-md-3 cards--col-md-4 cards--col-md-5 cards--col-md-6 products--col-1 products--col-2 products--col-3 products--col-4 products--col-5 products--col-6 products--col-sm-1 products--col-sm-2 products--col-sm-3 products--col-sm-4 products--col-sm-5 products--col-sm-6 products--col-md-1 products--col-md-2 products--col-md-3 products--col-md-4 products--col-md-5 products--col-md-6 ';
//
//
//   // List button
$('.sort-link--list').on('click', function(e){


		var type = $(this).data("type");
		var list = "";
		var list_sm = "";
		var list_md = "";



		if (type == "product") {

			if ($(this).data("list")) {list = " products--col-"+$(this).data("list");}
			if ($(this).data("list-sm")) {list_sm = " products--col-sm-"+$(this).data("list-sm");}
			if ($(this).data("list-md")) {list_md = " products--col-md-"+$(this).data("list-md");}

			var gridClasses = list + list_sm + list_md;

			$('.products').removeClass(globalGridClasses).addClass(gridClasses).addClass("products--list").removeClass("products--grid");
			$('.product').removeClass('product--grid').addClass("product--list");
		} else {

			if ($(this).data("list")) {list = " cards--col-"+$(this).data("list");}
			if ($(this).data("list-sm")) {list_sm = " cards--col-sm-"+$(this).data("list-sm");}
			if ($(this).data("list-md")) {list_md = " cards--col-md-"+$(this).data("list-md");}

			var gridClasses = list + list_sm + list_md;

			$('.cards-'+type).removeClass(globalGridClasses).removeClass("cards--grid card-"+type+"--grid").addClass(gridClasses).addClass("cards--list card-"+type+"--list");
			// $('.card-'+type+':not(.card--carousel)').addClass('card-'+type+'--list').removeClass('card-'+type+'--grid');
		}

		// sort menu - active state
		$('.sort-link--grid').removeClass('active');
		$(this).addClass('active');
		searchResultsObject[type.toUpperCase()]['gridSort'] = "list";

});
	// Grid button
	$('.sort-link--grid').on('click', function(e){

		var type = $(this).data("type");
		var grid = "";
		var grid_sm = "";
		var grid_md = "";

		if (type == "product") {

			if ($(this).data("grid")) {grid = " products--col-"+$(this).data("grid");}
			if ($(this).data("grid-sm")) {grid_sm = " products--col-sm-"+$(this).data("grid-sm");}
			if ($(this).data("grid-md")) {grid_md = " products--col-md-"+$(this).data("grid-md");}

			var gridClasses = grid + grid_sm + grid_md;

			$('.products').removeClass(globalGridClasses).removeClass("products--list").addClass(gridClasses).addClass("products--grid");
			$('.product').addClass('product--grid').removeClass("product--list");
		} else {

			if ($(this).data("grid")) {grid = " cards--col-"+$(this).data("grid");}
			if ($(this).data("grid-sm")) {grid_sm = " cards--col-sm-"+$(this).data("grid-sm");}
			if ($(this).data("grid-md")) {grid_md = " cards--col-md-"+$(this).data("grid-md");}

			var gridClasses = grid + grid_sm + grid_md;

			$('.cards-'+type).removeClass(globalGridClasses).removeClass("cards--list card-"+type+"--list").addClass(gridClasses).addClass("cards--grid card-"+type+"--grid");
			// $('.card-'+type+':not(.card--carousel)').addClass('card-'+type+'--grid').removeClass('card-'+type+'--list');
		}


		// sort menu - active state
		$('.sort-link--list').removeClass('active');
		$(this).addClass('active');
		searchResultsObject[type.toUpperCase()]['gridSort'] = "grid";

});



$('[data-js-toggle-events-search-filters]').on('click', function() {
		$('.events-results__filter-bar-extra').toggleClass('events-results__filter-bar-extra--active');
	});
//
//
//
//
//
//
//
//   // count bag items and add number to bag icon - header menus
//   var miniCartItems = $('.mini-cart__body .scroller')[1];
//   if (miniCartItems) {
//     miniCartItems = miniCartItems.children.length;
//     if (miniCartItems != 0) {
//       $('.js-bag-items-number').show();
//       $('.js-bag-items-number').text(miniCartItems);
//     }
//   }
//
//
//   // if (sliderStatus) {
//   //   $(this).parent().parent().addClass('on');
//   //   $(this).parent().parent().removeClass('off');
//   // } else {
//   //   $(this).parent().parent().removeClass('on');
//   //   $(this).parent().parent().addClass('off');
//   // }
// });



// if region notice - then push down pop out nav
// $(document).ready(function () {
//
//   if($('.region-bar').css('display') === 'block') {
//       $('body').addClass('is-region-notice');
//       $('#offcanvas-menu').addClass('w-region-notice');
//   }
//
//
//   $('.js-close-region-bar').on('click', function(){
//       $('body').removeClass('is-region-notice');
//       $('#offcanvas-menu').removeClass('w-region-notice');
//   });
//
//
// });

// from mega-menu.js
$(document).ready(function() {
	$("[js-mega-link]").on("mouseenter", function(e) {
		var height = document.getElementById("header").offsetHeight;
		$(this).next(".menu-dropdown").css("top", height);
	});
});


